<nav class="cabecera">
    <a class="regresar"><i class="fa fa-chevron-left" (click)="regresar()"></i></a>
    <h5>Semana {{ semana.semana }} - {{ corral }}</h5>
    <a data-target="slide-out" class="sidenav-trigger"><i class="fa fa-bars"></i></a>
</nav>
<div class="container">
    <div class="row">
        <div class="col s12">
            Semana
            <div class="input-field inline">
                <input id="email_inline" type="text" class="disabled" disabled value="{{semana.semana }}">
            </div>
        </div>
        <div class="col s12">
            Promedio
            <div class="input-field inline">
                <input id="promedio" type="text" class="disabled" disabled value="{{ semana.promedio }} gr.">
            </div>
        </div>
        <div class="input-field col s12">
            <table id="aves">
                <thead>
                    <tr>
                        <th>Aves</th>
                        <th width="70%">Peso</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ave of aves; index as i">
                        <td>{{ ( i + 1 ) }}</td>
                        <td>{{ ave }} gr.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col s12">
            <button class="btn waves-effect waves-light btn-large cancelar" type="button" (click)="regresar()">Regresar</button>
        </div>
    </div>
</div>
